export default __webpack_public_path__ + "static/media/GreenLake-BGImage.1937ce97.jpg";